// extracted by mini-css-extract-plugin
export default {"media":"style_media__foE1s","right-column":"style_right-column__x92x4","left-column":"style_left-column__2vNer"};